import { Button, Paper, useTheme } from "@mui/material";
import { AppointmentformData, GROUPING_OPTIONS } from "./fieldData";
import { UseFormReturn } from "react-hook-form";
import { useMutation } from "react-query";
import { useEffect } from "react";
import { getallClinician } from "../services";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";

function Refferealsform({ formcontrol }: { formcontrol: UseFormReturn }) {
  let gridContainer = "grid grid-cols-2 gap-3 px-2";
  const theme = useTheme();
  const { control, register } = formcontrol;
  const { mutate: getallClinicianList, data: clinicianList } =
    useMutation(getallClinician);

  let items = [
    { id: "Patients", type: "Patients" },
    { id: "Clinic Staff", type: "Clinic Staff" },
    { id: "News Paper", type: "News Paper" },
    { id: "Social Media", type: "Social Media" },
    { id: "Online Sites", type: "Online Sites" },
    { id: "Others", type: "Others" },
  ];

  let groups = GROUPING_OPTIONS;

  useEffect(() => {
    getallClinicianList();
  }, []);
  return (
    <div className="relative pt-3 h-full">
      <Paper className={`${gridContainer} py-5`}>
        <span
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
          }}
          className="absolute top-0 left-3 px-2 rounded"
        >
          Refferals &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <CustomFormField
          control={control}
          options={clinicianList?.response || []}
          {...AppointmentformData.refferedBy}
        />
        <CustomFormField
          control={control}
          options={items}
          {...AppointmentformData.referenceSource}
        />
        <CustomFormField
          control={control}
          options={groups}
          {...AppointmentformData.grouping}
        />
        <div className="hidden">
          <input
            id="uploadFile"
            type="file"
            {...register("uploadFile")}
            className="hidden"
          />
          <Button component="label" variant="outlined" htmlFor="uploadFile">
            upload file
          </Button>
        </div>
      </Paper>
    </div>
  );
}

export default Refferealsform;
